import { CheckCircleIcon } from '@heroicons/react/24/solid'

/** Checked / unchecked marker for the income allocation month readiness checklist. */
export function ReadinessCheckGlyph({ checked }: { checked: boolean }) {
  if (checked) {
    return (
      <CheckCircleIcon
        className="h-5 w-5 -m-0.5 text-emerald-600"
        aria-hidden="true"
      />
    )
  }
  return (
    <span
      className="block h-4 w-4 rounded-full border border-dashed border-gray-500"
      aria-hidden="true"
    />
  )
}
